{
  "nav": {
    "features": "Возможности",
    "formats": "Форматы",
    "screenshots": "Скриншоты",
    "download": "Скачать",
    "openSource": "Открытый код",
    "github": "GitHub"
  },
  "hero": {
    "title": "SaiPair",
    "subtitle": "Бесплатное ПО для управления турнирами",
    "description": "Настольное приложение с открытым кодом для организации турниров. Швейцарская система, круговой турнир, олимпийская система и другое.",
    "download": "Скачать сейчас",
    "viewOnGithub": "Смотреть на GitHub"
  },
  "features": {
    "title": "Возможности",
    "subtitle": "Всё необходимое для проведения турнира",
    "f1_title": "Множество форматов",
    "f1_desc": "Швейцарская система, круговой, двухкруговой, олимпийская система.",
    "f2_title": "Автоматическая жеребьёвка",
    "f2_desc": "Умный движок мгновенно генерирует пары.",
    "f3_title": "Рейтинг в реальном времени",
    "f3_desc": "Рейтинг обновляется в реальном времени с настраиваемыми правилами.",
    "f4_title": "Офлайн-режим",
    "f4_desc": "Интернет не нужен. Все данные хранятся локально.",
    "f5_title": "Импорт и экспорт",
    "f5_desc": "Импорт игроков из Excel/CSV. Экспорт рейтингов и жеребьёвок.",
    "f6_title": "Готово к печати",
    "f6_desc": "Печать списков, жеребьёвок, рейтингов и карточек игроков.",
    "f7_title": "Многоязычность",
    "f7_desc": "Доступно на 10 языках.",
    "f8_title": "Бесплатно и открыто",
    "f8_desc": "Лицензия MIT, всегда бесплатно."
  },
  "formats": {
    "title": "Форматы турниров",
    "subtitle": "Выберите подходящий формат",
    "swiss_title": "Швейцарская система",
    "swiss_desc": "Каждый тур формирует пары из игроков с похожими очками.",
    "roundRobin_title": "Круговой турнир",
    "roundRobin_desc": "Каждый играет с каждым.",
    "elimination_title": "Олимпийская система",
    "elimination_desc": "Проигравшие выбывают в каждом раунде.",
    "doubleElim_title": "Двойная олимпийская",
    "doubleElim_desc": "У игроков есть второй шанс."
  },
  "screenshots": {
    "title": "Скриншоты",
    "subtitle": "SaiPair в действии",
    "placeholder": "Скриншоты скоро — скачайте и попробуйте сами!"
  },
  "download": {
    "title": "Скачать",
    "subtitle": "Доступно для Windows, macOS и Linux",
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "getLatest": "Скачать последнюю версию",
    "allReleases": "Все версии"
  },
  "openSource": {
    "title": "Открытый код",
    "subtitle": "Открытая разработка, лицензия MIT",
    "description": "SaiPair — свободное ПО с открытым кодом. Приветствуется участие каждого.",
    "github": "Репозиторий GitHub",
    "issues": "Сообщить о проблеме",
    "discussions": "Присоединиться к обсуждению"
  },
  "footer": {
    "copyright": "© {{year}} SaiPair. Лицензия MIT.",
    "madeWith": "Сделано с ❤ для организаторов турниров по всему миру."
  },
  "language": {
    "en": "English",
    "zh-CN": "中文",
    "es": "Español",
    "fr": "Français",
    "pt": "Português",
    "ru": "Русский",
    "ja": "日本語",
    "ar": "العربية",
    "hi": "हिन्दी",
    "bn": "বাংলা"
  }
}
